module.exports = __webpack_public_path__ + "img/25.0225b453.jpg";